import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { CalendarContentProps } from "./Calendar.types";
import dayjs from "dayjs";
import { getJobTypeLabel } from "../_function/common";
import { columns } from "./ListColumn";
import { Button, Typography } from "@mui/material";
import { ArrowBack, ArrowForward, Refresh } from "@mui/icons-material";
import { ListScheduleCleaningProjection } from "../../../hooks/scheduled_jobs/index.type";

export default function ListView({
  dateContents,
  month,
  year,
  handleSelectDate,
  onSelectRow,
  onRefetch
}: {
  month: string,
  year: string,
  handleSelectDate?: (date: Date) => void,
  dateContents?: {
    delivery: CalendarContentProps[],
    cleaning: ListScheduleCleaningProjection[]
  },
  onSelectRow?: (data: CalendarContentProps | ListScheduleCleaningProjection) => void,
  onRefetch?: () => void
}) {

  const listData = dateContents ? [
    ...dateContents.delivery,
    ...dateContents.cleaning
  ].sort((a, b) => {
    const aTimestamp = (a as CalendarContentProps)?.timestamp || (a as ListScheduleCleaningProjection).start_timestamp
    const bTimestamp = (b as CalendarContentProps)?.timestamp || (b as ListScheduleCleaningProjection).start_timestamp

    return aTimestamp > bTimestamp ? 1 : -1
  }).map((item, index) => ({
    ...item,
    id: index + 1
  })) : []
  return (
    <div>
      <div style={{
        display: 'flex',
        flexDirection: 'row',
        padding: '8px'
      }}>
        <div className="calendar-header">
          <Typography variant="body1" textAlign={'left'}>
            {month} {year}
          </Typography>
        </div>

        <div style={{
          display: "flex",
          flexDirection: 'row'
        }}>
          {!!onRefetch && (
            <Button
              sx={{
                color: '#23c667'
              }}
              onClick={() => onRefetch()}>
              <Refresh />
            </Button>
          )}
          <Button
            sx={{
              color: '#23c667'
            }}
            onClick={() => handleSelectDate?.(dayjs(year + '-' + month + '-01').subtract(1, 'month').toDate())}>
            <ArrowBack />
          </Button>
          <Button
            sx={{
              color: '#23c667'
            }}
            onClick={() => handleSelectDate?.(dayjs(year + '-' + month + '-01').add(1, 'month').toDate())}
          >
            <ArrowForward />
          </Button>
        </div>
      </div>
      <DataGrid
        rows={listData}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 25,
            },
          },
        }}
        pageSizeOptions={[25]}
        // checkboxSelection
        // disableRowSelectionOnClick
        disableMultipleRowSelection
        onRowClick={(param) => onSelectRow?.(param.row)}
      />
    </div>
  )
}